import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { PatientInfo } from '../types';

interface PatientState {
  patientInfo: PatientInfo;
  setPatientInfo: (info: Partial<PatientInfo>) => void;
  resetPatient: () => void;
  isValid: () => boolean;
}

const defaultPatientInfo: PatientInfo = {
  name: '',
  birthDate: '',
  testDate: new Date().toISOString().split('T')[0],
  examiner: '',
  institution: '',
  notes: '',
};

export const usePatientStore = create<PatientState>()(
  persist(
    (set, get) => ({
      patientInfo: { ...defaultPatientInfo },

      setPatientInfo: (info) =>
        set((state) => ({
          patientInfo: { ...state.patientInfo, ...info },
        })),

      resetPatient: () =>
        set({ patientInfo: { ...defaultPatientInfo } }),

      isValid: () => {
        const { name, birthDate, testDate, examiner } = get().patientInfo;
        return !!(name && birthDate && testDate && examiner);
      },
    }),
    {
      name: 'wiscv-patient',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
